import { LoginRoutes } from 'src/app/login/models/login-routes.model'

export const EvidaRoutes = {
    evida: 'evida',
    frontpage: 'frontpage',
    invoice: 'invoice',
    consumption: {
        root: 'consumption',
        development: 'development',
        timedata: 'timedata',
        capacitySubmission: 'capacity-submission',
    },
    productionreadings: 'production-readings',
    profile: {
        root: 'profile',
        myprofile: 'myprofile',
        admin: 'admin',
    },
}

export const EvidaFullRoutes = {
    frontpage: EvidaRoutes.evida,
    invoice: `${EvidaRoutes.evida}/${EvidaRoutes.invoice}`,
    timedata: `${EvidaRoutes.evida}/${EvidaRoutes.consumption.root}/${EvidaRoutes.consumption.timedata}`,
    development: `${EvidaRoutes.evida}/${EvidaRoutes.consumption.root}/${EvidaRoutes.consumption.development}`,
    capacitySubmission: `${EvidaRoutes.evida}/${EvidaRoutes.consumption.root}/${EvidaRoutes.consumption.capacitySubmission}`,
    capacitySubmissionFlow: `flow/${EvidaRoutes.consumption.capacitySubmission}`,
    capacitySubmissionDetails: `flow/${EvidaRoutes.consumption.capacitySubmission}/details`,
    capacitySubmissionReceipt: `flow/${EvidaRoutes.consumption.capacitySubmission}/receipt`,
    productionreadings: `${EvidaRoutes.evida}/${EvidaRoutes.productionreadings}`,
    profile: `${EvidaRoutes.evida}/${EvidaRoutes.profile.root}/${EvidaRoutes.profile.myprofile}`,
    admin: `${EvidaRoutes.evida}/${EvidaRoutes.profile.root}/${EvidaRoutes.profile.admin}`,
    logout: `/${LoginRoutes.login}/${LoginRoutes.logout}`,
}
